import React from "react";
import { useSelector } from "react-redux";
import Header from "../common/Header";
import OrdersList from "./OrdersList";
import { StyledBody } from "./styled";
import { getMerchantConfig } from "features/config/configSlice";

function Orders({ setLoginLoader }) {
  const merchantConfig = useSelector(getMerchantConfig);
  return (
    <StyledBody>
      <Header />
      <OrdersList setLoginLoader={setLoginLoader} />
    </StyledBody>
  );
}

export default Orders;
